/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import useRouter from 'packages/hooks/use-router';
import {useTheme} from '@material-ui/core';
import clsx from 'clsx';
import useStyles from '../admin-styles';

type NavItemProps = {
  to: string;
  path: string;
  children: React.ReactNode;
};

const NavigationItem = ({path, to, children}: NavItemProps) => {
  const {history, match, location} = useRouter();
  const {palette} = useTheme();
  const classes = useStyles();
  const navigate = () => {
    history.push(`${match.url}${to}`);
  };

  return (
    <li
      className={clsx([classes.nav_navigation_item])}
      style={{
        color: location.pathname === path ? palette.primary.main : `#000`,
      }}
      onClick={navigate}
    >
      {children}
    </li>
  );
};

const NAVIGATION_MAP = [
  {name: `Torneos`, path: `/admin`, to: ``},
  {name: `Cuentas`, path: `/admin/accounts`, to: `/accounts`},
  {name: `Clubes`, path: `/admin/clubs`, to: `/clubs`},
  {name: `Enfrentamientos`, path: `/admin/rounds`, to: `/rounds`},
  {name: `Tabla de posiciones`, path: `/admin/standings`, to: `/standings`},
  {name: `Ranking nacional`, path: `/admin/national`, to: `/national`},
];

const NavigationList = () => {
  const classes = useStyles();
  return (
    <ul className={classes.nav_navigation_list}>
      {NAVIGATION_MAP.map(({name, path, to}) => {
        return (
          <NavigationItem key={path} path={path} to={to}>
            {name}
          </NavigationItem>
        );
      })}
    </ul>
  );
};

export default NavigationList;
